import '../scss/styles.scss';

/* PDF-links openen in een nieuw venster */
document.querySelectorAll('a').forEach((linkElem: Element) => {
	if (linkElem.hasAttribute('href') && linkElem.getAttribute('href')?.endsWith('.pdf')) {
		linkElem.setAttribute('target', '_blank');
	}
});

/* E-mailadressen tegen spam: de delen staan los in de HTML en worden hier
   samengevoegd tot een mailto-link. */
setTimeout(function () {
	const mailElement = document.querySelectorAll('[data-madr1]:not(.madr-done)');

	mailElement.forEach((mail: Element) => {
		const maddr = mail.getAttribute('data-madr1') + '@' + mail.getAttribute('data-madr2') + '.' + mail.getAttribute('data-madr3');
		const linktext = mail.getAttribute('data-linktext') ? mail.getAttribute('data-linktext') : maddr;

		const a = document.createElement('a');
		a.setAttribute('href', `mailto:${maddr}`);
		a.innerHTML = linktext || '';

		if (mail.parentElement) mail.parentElement.appendChild(a);
		mail.classList.add('madr-done');
		(mail as HTMLElement).style.display = 'none';
	});
}, 500);

/* Knop terug naar boven */
const themeTop = document.querySelector('#theme-to-top');
if (themeTop) {
	themeTop.addEventListener('click', (e) => {
		e.preventDefault();

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	});
}

/* Scrollgedrag: schaduw onder de navigatie en de knop terug naar boven.

   De handler is passief en rekent hooguit een keer per beeldframe, zodat
   scrollen niet gaat haperen op lange pagina's. De hoogte van de balk
   verandert niet tijdens het scrollen en wordt daarom alleen bij resize
   opnieuw gemeten. */
const navheader = document.querySelector('#theme-page-navigation') as HTMLElement | null;
const bc = document.querySelector('.theme-page-breadcrumb') as HTMLElement | null;
const toTop = document.querySelector('#theme-to-top') as HTMLElement | null;

if (navheader || bc || toTop) {
	let navHeight = 0;
	let ticking = false;

	const measure = () => {
		navHeight = navheader ? navheader.offsetHeight : 0;
	};

	const update = () => {
		ticking = false;

		if (navheader) {
			navheader.classList.toggle('theme-nav-scrolled', window.scrollY > 8);
		}

		if (toTop) {
			toTop.classList.toggle('theme-top-visible', window.scrollY > 200);
		}
	};

	measure();
	update();

	window.addEventListener('scroll', () => {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	}, { passive: true });

	window.addEventListener('resize', measure);
}

/* Zoeken in de navigatie.

   Er staat bewust geen <form> in de HTML: DNN wikkelt de hele pagina al in
   <form id="Form"> en een geneste form gooit de browser weg. Verzenden gebeurt
   daarom hier, door naar de zoekpagina te navigeren.

   Zonder script blijft het veld openstaan — een vergrootglas dat niets doet is
   slechter dan een zichtbaar zoekveld. De klasse js-ready schakelt het
   inklappen pas in als dit script gedraaid heeft. */
document.querySelectorAll('.theme-nav-search').forEach((search: Element) => {
	const toggle = search.querySelector('.theme-nav-search__toggle') as HTMLButtonElement | null;
	const input = search.querySelector('input') as HTMLInputElement | null;
	if (!toggle || !input) return;

	const url = search.getAttribute('data-search-url') || '/Search-Results';

	search.classList.add('js-ready');
	toggle.setAttribute('aria-expanded', 'false');

	const open = (on: boolean) => {
		search.classList.toggle('is-open', on);
		toggle.setAttribute('aria-expanded', String(on));
		if (on) input.focus();
	};

	const submit = () => {
		const term = input.value.trim();
		if (term === '') return;
		// DNN's zoekpagina leest de term uit de querystring-parameter Search.
		const sep = url.indexOf('?') === -1 ? '?' : '&';
		window.location.href = url + sep + 'Search=' + encodeURIComponent(term);
	};

	// Het vergrootglas opent het veld, en verzendt zodra er iets ingevuld is.
	// Zo is er maar een knop nodig, precies zoals in het ontwerp.
	toggle.addEventListener('click', () => {
		if (!search.classList.contains('is-open')) return open(true);
		if (input.value.trim() !== '') return submit();
		open(false);
	});

	input.addEventListener('keydown', (e: KeyboardEvent) => {
		if (e.key === 'Enter') {
			// Zonder dit doet DNN een postback van het omliggende formulier.
			e.preventDefault();
			submit();
			return;
		}

		// Escape sluit het veld weer; anders is er zonder muis geen uitweg.
		if (e.key === 'Escape') {
			open(false);
			toggle.focus();
		}
	});

	// Klik buiten het blok sluit het, maar alleen als er niets ingetypt is —
	// anders raakt iemand halverwege zijn zoekterm kwijt.
	document.addEventListener('click', (e: Event) => {
		if (search.contains(e.target as Node)) return;
		if (input.value.trim() !== '') return;
		open(false);
	});
});

/* Kruimelpad: op een smal scherm wordt het pad ingekort tot "..." plus de
   huidige pagina. De trigger klapt de rest weer uit. */
if (bc) {
	const bcTrigger = bc.querySelector('.breadcrumb-item-trigger') as HTMLElement | null;
	const bcHome = bc.querySelector('.breadcrumb-item-home') as HTMLElement | null;

	if (bcTrigger && bcHome) {
		bcTrigger.addEventListener('click', () => {
			bcHome.style.display = bcHome.style.display === 'none' ? 'inline-block' : 'none';
		});

		const many = bc.querySelectorAll('.breadcrumb-item').length > 2;
		bcTrigger.style.display = many ? 'inline-block' : 'none';
		bcHome.style.display = many ? 'none' : 'inline-block';
	}
}
